export default "__VITE_ASSET__BNLd8kiJ__"